<template>
  <div>
    <v-breadcrumbs item-text="text" :items="breadcrumbs"></v-breadcrumbs>
    <v-card-title> Create Invoice :
      <v-btn class="ms-2" color="primary"> {{ submitData.invoice_type }}</v-btn>
    </v-card-title>
    <v-row>
      <v-col cols="12" md="3" sm="5">
        <div>
          <template>
            <v-card class="mx-auto" max-width="" variant="outlined">
              <div>
                <div class="text-overline mb-1 ms-2">
                  <v-btn color="orange" style="margin-top: 5px">
                    Patient ID: <b>{{ patient_info.patient_id }}</b>
                  </v-btn>
                </div>
                <div class="text-h6 mb-1 ms-2 " style="font-weight: bold">
                  {{ patient_info.patient_name }}
                </div>
                <div class="text-caption ms-2">Gender: <b>{{ patient_info.patient_sex }}</b> | Age: <b>{{
                    patient_info.patient_age
                  }}</b></div>
              </div>
            </v-card>
          </template>
        </div>
      </v-col>
      <v-col cols="12" md="6" sm="5">
        <div>
          <template>
            <v-card class="mx-auto" max-width="" variant="outlined">
              <div>
                <div class="text-overline mb-1 ms-2">
                  <v-btn color="orange" style="margin-top: 5px">
                    Reference
                  </v-btn>
                </div>
                <div class="text-h6 mb-1 ms-2 " style="font-weight: bold">
                  {{ patientSource.ps_name }}
                </div>
                <div class="text-caption ms-2">Consultation Discount : <b>{{ patientSource.ps_con_discount + '%' }}</b>
                  | Investigation Discount: <b>{{ patientSource.ps_invs_discount + '%' }} </b> | Operation Discount:
                  <b>{{ patientSource.ps_op_discount + '%' }}</b></div>
              </div>
            </v-card>
          </template>
        </div>
      </v-col>
      <v-col cols="3" v-if="submitData.family_eye_card_no">
        <div>
          <template>
            <v-card class="mx-auto" max-width="" variant="outlined">
              <div>
                <div class="text-overline mb-1 ms-2">
                  <v-btn color="orange" style="margin-top: 5px">
                    Family Eye Card
                  </v-btn>
                </div>
                <div class="text-h6 mb-1 ms-2 " style="font-weight: bold">
                  <v-text-field
                      v-model="submitData.family_eye_card_no"
                      hide-details="auto"
                      solo
                      dense
                      readonly
                  ></v-text-field>
                  <div class="spacing-playground pa-2"></div>
                </div>
              </div>
            </v-card>
          </template>
        </div>
      </v-col>
    </v-row>
    <v-card style="margin-top: 10px" :loading="loading">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <v-autocomplete
                :items="doctors"
                v-model="submitData.refer_doctor"
                item-text="dr_name"
                item-value="id"
                required
                label="Select Refer Doctor"
                outlined
                dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" :class="displayNone">
            <v-autocomplete
                :items="doctors"
                v-model="submitData.refer_incentive_dr_id"
                item-text="dr_name"
                item-value="id"
                required
                label="Select PRE-LASIK Refer Doctor"
                outlined
                dense
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="9">
            <div v-for="(item, index) in repeaterItems" :key="index">
              <v-row>
                <v-col cols="12" md="6">
                  <div class="d-flex">
                    <div class="mr-2 mt-2" style="color: #0a53be; ">{{ index + 1 }}.</div>
                    <v-autocomplete
                        :items="investigations"
                        v-model="item.investigation_id"
                        item-text="name"
                        item-value="id"
                        required
                        label="Select Investigation"
                        outlined
                        dense
                        @change="getInvestigationDetails(item.investigation_id, index)"
                    ></v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="6" md="2">
                  <v-autocomplete
                      :items="eyeTypes"
                      v-model="item.eye_type"
                      required
                      label="Eye Type"
                      outlined
                      dense
                      @change="getInvestigationDetails(item.investigation_id, index)"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" md="2">
                  <v-text-field class="ms-2"
                                label="Amount"
                                v-model="item.amount"
                                outlined
                                dense
                                type="number"
                                prefix="৳"
                  ></v-text-field>
                  <v-progress-linear indeterminate v-if="amountLoading"></v-progress-linear>
                </v-col>
                <v-col cols="2" md="2">
                  <v-btn @click="removeItem(index)" color="error" class="ms-2">
                    <v-icon>mdi-delete-forever</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="2" md="2">
                <v-btn @click="addItem" class="ms-2" color="blue">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card style="margin-top: 10px; margin-bottom: 50px">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field label="Sub Total Amount" v-model="subTotalAmount" outlined dense type="number"
                              prefix="৳" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex">
                  <v-text-field label="Discount" v-model="submitData.discount_percentage" outlined dense type="number"
                                prefix="%" disabled></v-text-field>
                  <v-btn class="ms-2" @click="openRecommendedModal" color="warning" small>
                    <v-icon small>
                      mdi-checkbox-marked
                    </v-icon>
                    Recommended
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Total Amount" v-model="submitData.total_amount" outlined dense type="number"
                              prefix="৳" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Paid Amount" v-model="submitData.paid_amount" outlined dense type="number"
                              prefix="৳"></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field label="Due Amount" v-model="dueAmount" outlined dense type="number"
                              prefix="৳" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <v-autocomplete
                    :items="paymentMethods"
                    v-model="submitData.payment_method"
                    item-text="name"
                    item-value="name"
                    required
                    label="Payment Method"
                    outlined
                    dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" v-if="spinnerButtons">
                <v-progress-circular :width="12" size="61" color="green" indeterminate
                                     style="margin-top: 5px; margin-bottom: 10px"></v-progress-circular>
              </v-col>
              <v-col cols="12" md="4" v-else>
                <v-btn depressed color="success" :disabled="btnSubmit" class="mx-2" @click="formSubmit">
                  Submit
                </v-btn>
                <v-btn depressed color="info" v-if="this.invoice_id" @click="print('invoice')">
                  <v-icon>mdi-printer</v-icon>
                  Invoice Print
                </v-btn>
              </v-col>

            </v-row>

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="450">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> Add Recommended Discount
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row no-gutters class="mt-1">
                  <v-col cols="12" md="12">
                    <v-autocomplete
                        :items="doctors"
                        v-model="recommendedData.dr_id"
                        item-text="dr_name"
                        item-value="id"
                        label="Recommender Doctor Name *"
                        required
                        outlined
                        dense
                        chips
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-autocomplete
                        :items="discountList"
                        v-model="recommendedData.discount_percentage"
                        label="Discount *"
                        required
                        outlined
                        dense
                        chips
                        prefix="%"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field
                        label="Description"
                        v-model="recommendedData.description"
                        outlined dense>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="dialogCancel()"> Cancel</v-btn>
              <v-btn color="success" @click="addRecommendedData()"> Add</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

    </template>
  </div>
</template>
<script>

import atshq from "../../../js/setup";
import moment from "moment";
// import PermissionName from "@/js/PermissionName";

export default {
  data() {
    return {
      amountLoading: false,
      spinnerButtons: true,
      displayNone: 'd-none',
      dialog: false,
      loading: true,
      date: moment().format('YYYY-MM-DD'),
      nowDate: moment().format('YYYY-MM-DD'),
      btnSubmit: true,
      pre_lasik_investigations: [],
      items: [],
      patient_info: [],
      appointment: [],
      paymentMethods: [],
      discountList: [
        0,
        5,
        10,
        15,
        20,
        25,
        30,
        35,
        40,
        45,
        50,
        55,
        60,
        65,
        70,
        75,
        80,
        85,
        90,
        95,
        100,
      ],
      investigations: [],
      doctors: [],
      invoice_discount: 0,
      row: null,
      eyeTypes: ['Left', 'Right', 'Both'],
      repeaterItems: [{investigation_id: null, eye_type: '', amount: ''}],
      submitData: {
        patient_id: this.$route.params.id,
        refer_doctor: parseInt(this.$route.query.refer_doctor),
        sub_total_amount: 0,
        discount_amount: 0,
        total_amount: 0,
        paid_amount: 0,
        due_amount: 0,
        cashback_amount: 0,
        patient_source_name: '',
        discount_recommended_dr_id: '',
        family_eye_card_no: '',
        discount_percentage: 0,
        discount_recommended_desc: '',
        payment_method: 'Cash',
        invoice_type: 'investigation',
        login_user_id: localStorage.getItem("userId"),
        local_ip_address: localStorage.getItem("local_ip_address"),
        refer_incentive_dr_id: '',
        dr_incentive_status: '',
      },
      recommendedData: {
        dr_id: '',
        discount_percentage: '',
        description: '',
      },
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoices",
          disabled: false,
          href: "/invoices",
        },
        {
          text: "Create Invoice",
          disabled: true,
          href: "",
        },
      ],
      patientSource: [],
      familyCard: [],
      pre_lasik_inv_refer_status: '',
      isLoading: false,
      search: null,
      printBtn: true,
      invoice_id: null,
      invoice_created_msg: null,
      apiUrl: atshq.defaults.headers.common.api_URL,
      baseUrl: atshq.defaults.headers.common.base_URL,
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  created() {
    if (this.submitData.patient_id) {
      this.getPatient(this.submitData.patient_id);
    }
    this.getPaymentMethods();
    this.getDoctors()
    this.getInvestigations()
    this.getFromParameters()
  },
  mounted() {
    // this.permissionExists(PermissionName.CREATE_INVESTIGATION_INVOICE);
  },
  methods: {
    getFromParameters() {
      if (this.$route.query.investigations) {
        let selectedInvestigations = (this.$route.query.investigations).split(',')
        let selectedInvestigationTypes = (this.$route.query.investigation_type).split(',')
        for (let i = 0; i < selectedInvestigations.length; i++) {
          this.repeaterItems = []
          atshq
              .get("/investigations/report-setup/" + parseInt(selectedInvestigations[i]))
              .then((response) => {
                let investigation = response.data.investigation;
                if (investigation) {
                  if (selectedInvestigations[i] && selectedInvestigationTypes[i]) {
                    let amount = 0;
                    amount = investigation.one_eye_charge
                    if (selectedInvestigationTypes[i] === 'Both') {
                      amount = investigation.both_eye_charge
                    }
                    this.repeaterItems.push({
                      investigation_id: parseInt(selectedInvestigations[i]),
                      eye_type: selectedInvestigationTypes[i],
                      amount: amount
                    })
                  }
                }
              })
              .catch((e) => {
                this.$noty.error(e.response.message)
              });
        }
      }
    },
    formSubmit() {

      console.log('innn',this.repeaterItems)
      const allValuesPresent = this.missingValuesCheck()
      if (allValuesPresent) {
        if (!(this.submitData.paid_amount >= 0 && this.submitData.due_amount >= 0)) {
          this.$noty.error('Paid and Due amount must be greater than or equal 0')
          return
        }
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'success',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, submit it!'
        }).then((result) => {
          if (result.value) {
            this.spinnerButtons = true;
            this.btnSubmit = true
            let submitUrl = "invoices/invoice-investigation-create";
            atshq
                .post(submitUrl, {submitData: this.submitData, investigationItems: this.repeaterItems})
                .then((response) => {
                  this.invoice_id = response.data.invoice_id;
                  this.invoice_created_msg = 'Successfully Save Invoice No: ' + this.invoice_id;
                  this.$noty.success(response.data.message);
                  //window.open(this.returnUrl + "printdoc/invoice/" + this.invoice_id + "/0")
                  this.$router.replace({'query': null});
                  this.repeaterItems = []
                  this.repeaterItems.push({investigation_id: null, eye_type: '', amount: ''})
                  this.submitData.refer_doctor = ''
                  this.spinnerButtons = false;
                })
                .catch((e) => {
                  this.btnSubmit = false
                  this.$noty.error(e.response.data.message);
                  this.spinnerButtons = false;
                });
          }
        });
      }
    },
    getInvestigationDetails(investigation_id, index) {
      let item = this.repeaterItems[index];
      if (item.eye_type) {
        this.amountLoading = true
      }
      atshq
          .get("/investigations/report-setup/" + investigation_id)
          .then((response) => {
            let item = this.repeaterItems[index];
            let investigation = response.data.investigation;
            if (investigation) {
              if (item.investigation_id && item.eye_type) {
                if (item.eye_type === 'Both') {
                  item.amount = investigation.both_eye_charge
                } else {
                  item.amount = investigation.one_eye_charge
                }
                this.amountLoading = false
              } else {
                item.amount = null
              }
            }
          })
          .catch((e) => {
            this.$noty.error(e.response.message)
          });
    },
    getDoctors() {
      atshq
          .get("/doctors?status=1")
          .then((response) => {
            this.doctors = response.data.data;
            this.spinnerButtons = false;
          })
          .catch((e) => {
            console.log(e)
          });
    },
    getInvestigations() {
      atshq
          .get("/investigations/get-investigation-opd-lists")
          .then((response) => {
            this.investigations = response.data.investigations;
            this.pre_lasik_investigations = response.data.pre_lasik_investigations
            this.pre_lasik_inv_refer_status = response.data.pre_lasik_inv_refer_status
            this.loading = false
            this.btnSubmit = false
          })
          .catch((e) => {
            console.log(e)
          });
    },
    getPaymentMethods() {
      atshq
          .get("/payment-methods")
          .then((response) => {
            this.paymentMethods = response.data.data;
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
          });
    },
    getPatient(patient_id) {
      atshq
          .get("patients/patients/" + patient_id)
          .then((response) => {
            this.patient_info = response.data.data;
            this.patientSource = response.data.data.corporate_client;
            if (this.patientSource) {
              this.submitData.discount_percentage = this.patientSource.ps_invs_discount
              this.submitData.patient_source_name = this.patientSource.ps_name
            }
            // this.familyEyeCard = response.data.familyEyeCard
            if (response.data.familyEyeCard !== null) {
              this.familyCard = response.data.familyEyeCard
              this.submitData.family_eye_card_no = this.familyCard.card_no
            }
          })
          .catch((e) => {
            console.log(e)
          });
    },
    print(type) {
      if (type === 'invoice') {
        window.open(this.returnUrl + "printdoc/invoice/" + this.invoice_id + "/0");
      }
    },
    openRecommendedModal() {
      this.dialog = true;
      if (this.recommendedData.dr_id == null || this.recommendedData.dr_id === '') {
        this.recommendedData.dr_id = this.submitData.refer_doctor
      }
    },
    addRecommendedData() {
      if (!(this.recommendedData.dr_id && this.recommendedData.discount_percentage)) {
        this.$noty.error('All the fields must be required')
        return
      }
      this.submitData.discount_recommended_dr_id = this.recommendedData.dr_id
      this.submitData.discount_percentage = this.recommendedData.discount_percentage
      this.submitData.discount_recommended_desc = this.recommendedData.description
      this.dialog = false
    },
    dialogCancel() {
      this.recommendedData.dr_id = ''
      this.recommendedData.discount_percentage = 0
      this.recommendedData.description = ''

      this.submitData.discount_recommended_dr_id = this.recommendedData.dr_id
      if (this.patientSource) {
        this.submitData.discount_percentage = this.patientSource.ps_invs_discount
      }
      this.submitData.discount_recommended_desc = this.recommendedData.description

      this.dialog = false
    },
    missingValuesCheck() {
      return this.repeaterItems.every((object, index) => {
        const missingValues = [];
        const hasAllValues = Object.keys(object).every(key => {
          if (object[key] === undefined || object[key] === null || object[key] === '' || object[key] < 1) {
            missingValues.push(key);
            return false;
          }
          return true;
        });
        if (!hasAllValues) {
          if (missingValues.join(', ') === 'investigation_id') {
            this.$noty.error(`At line ${index + 1}, investigation  is required.`)
          } else if (missingValues.join(', ') === 'eye_type') {
            this.$noty.error(`At line ${index + 1}, eye type  is required.`)
          } else if (missingValues.join(', ') === 'amount') {
            this.$noty.error(`At line ${index + 1}, amount value must be larger than 0`)
          } else {
            this.$noty.error(`At line ${index + 1} has missing value: ${missingValues.join(', ')}`);
          }
        }
        return hasAllValues;
      });
    },
    addItem() {
      const allValuesPresent = this.missingValuesCheck()
      if (allValuesPresent) {
        this.repeaterItems.push({investigation_id: null, eye_type: '', amount: ''})
      }
    },
    removeItem(index) {
      this.repeaterItems.splice(index, 1)
    },
  },
  computed: {
    subTotalAmount() {
      var t = this
      t.submitData.sub_total_amount = 0
      this.repeaterItems.forEach(item => {
        if (item.investigation_id && item.eye_type && (item.amount > 1)) {
          t.submitData.sub_total_amount += parseInt(item.amount)
        }
      })
      t.submitData.discount_amount = t.submitData.sub_total_amount * (t.submitData.discount_percentage / 100)
      t.submitData.total_amount = t.submitData.sub_total_amount - t.submitData.discount_amount
      t.submitData.paid_amount = t.submitData.total_amount
      t.submitData.due_amount = 0
      return t.submitData.sub_total_amount;
    },
    dueAmount() {
      var t = this
      t.submitData.due_amount = t.submitData.total_amount - t.submitData.paid_amount
      return t.submitData.due_amount
    }
  }
};
</script>